import  React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import {inject, observer} from 'mobx-react'

import {
	SIDEBARS_BOTTOM,
	SIDEBARS_TOP,
	SIDEBARS_TOP_EXAM_PREP
} from '../../../constants/sideBar';
// import {TOPIC_TYPE_NAME} from 'constants/topicTypes';

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('examPrepHeaderStore')
@observer
export default class UserLogIn extends React.Component{

  componentDidMount(){
    this.routerListener = this.props.history.listen(() => {
      this.props.sideBarStore.deactivate();
    });
  }

  componentWillUnmount(){
    this.routerListener();
  }
	
	renderButtons = (topic) => {
    return (
      <div className='sidebar-exam-prep'>
        <NavLink className="sidebar-item" to={`/exam-prep/topic/${topic.id}`}>
					<span>{topic.title}</span>
        </NavLink>
        <NavLink className="sidebar-item" to={`/exam-prep/${topic.id}/topics`}>
					<span>Clinical Topics</span>
        </NavLink>
        <NavLink className="sidebar-item" to={`/exam-prep/${topic.id}/resources`}>
          OSCEs
        </NavLink>
        <NavLink className="sidebar-item" to={`/exam-prep/${topic.id}/mcq`}>
          MCQs
        </NavLink>
        <NavLink className="sidebar-item" to={`/exam-prep/${topic.id}/clinical-notes-writing`}>
          Clinical Notes Writing
        </NavLink>
      </div>
    );
  };

  handleShowButtons = (topic, showButtons) => {
		const {isSubscribed} = this.props.userStore;

    if (showButtons || isSubscribed) {
      return this.renderButtons(topic);
    }

    return null;
  };

	render() {
		const {user, isSubscribed} = this.props.userStore;
    const {topic, showButtons} = this.props.examPrepHeaderStore;
		const showExamPrep = user.role !== 'admin';
		const topSidebarTabs = showExamPrep ? SIDEBARS_TOP_EXAM_PREP : SIDEBARS_TOP;
		const topSidebar = topSidebarTabs.map((item, index) => {
			const {title, link} = item;

			return (isSubscribed && title === 'Dashboard') ? null : (
				<NavLink
					key={index}
					exact
					to={link}
					activeClassName="active"
					className="sidebar-item">
					{title}
				</NavLink>
			)
		});
		const bottomSidebar = SIDEBARS_BOTTOM.map((item, index) => {
			const {title, link} = item;

			return (
				<NavLink
					key={index}
					to={link}
					exact
					activeClassName="active"
					className="sidebar-item">
					{title}
				</NavLink>
			)
		});

		return(
			<div className="sidebar-wrapper">
				{topSidebar}
				{this.handleShowButtons(topic, showButtons)}
				<Divider className="sidebar-divider" />
				{bottomSidebar}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/core/containers/UserLogIn.js